import {
    BlankModal,
    HStack,
    ModalBody,
    ModalFooter,
    ModalHeader,
    VStack,
    Button,
    Text,
} from '@cad-arc';
import { useUnitEmergency } from './use-unit-emergency';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';

export type UnitEmergencyCancelModalComponentType = typeof UnitEmergencyCancelModal;

export function UnitEmergencyCancelModal({ cancel }: { cancel: () => void }) {
    const { secondsRemaining } = useUnitEmergency();
    const modalControls = useFullscreenModalControls();
    const cancelTimer = () => {
        modalControls.close();
        cancel();
    };

    return (
        <BlankModal
            isCentered
            isOpen={true}
            onClose={() => modalControls.close()}
            closeOnEsc={false}
            closeOnOverlayClick={false}
        >
            <ModalHeader>Cancel Unit Emergency Timer</ModalHeader>
            <ModalBody>
                <VStack width="100%" alignItems="start">
                    <Text>Are you certain you wish to cancel the emergency alert?</Text>
                </VStack>
            </ModalBody>
            <ModalFooter>
                <HStack>
                    <Text variant="headingXs" color="brand">
                        Sending alert in {secondsRemaining} seconds
                    </Text>
                    <Button variant="solid" onClick={() => cancelTimer()}>
                        Cancel
                    </Button>
                </HStack>
            </ModalFooter>
        </BlankModal>
    );
}
